import weDOSectionStaffSol from "data/weDOSectionStaffSol";
import React, { useState } from "react";
import { Col, Image, Row } from "react-bootstrap";
import VisibilitySensor from "react-visibility-sensor";
import TextSplit from "../Reuseable/TextSplit";

const { title, title2, featuredImage, text, barTitle, barPercent, HCDLDP, HCCS } = weDOSectionStaffSol;

const WeDOSectionStaffSol = () => {
  const [countStart, setCountStart] = useState(false);
  const [currentHCDLDP, setCurrentHCDLDP] = useState(1);
  const [currentHCCS, setCurrentHCCS] = useState(1);


  const onVisibilityChange = (isVisible) => {
    if (isVisible) {
      setCountStart(true);
    }
  };

  return (
    <section className="we-do-section-staff-sol mb-5">
      <div className="auto-container">
        <Row >
          <Col lg={6} md={12} sm={12} className="right-col">
            <div className="inner">
              <div className="sec-title">
                <h5>
                  <TextSplit text={title} />
                  <span className="dot">.</span>
                </h5>
              </div>
              <div className="faq-box">
                <ul className="accordion-box clearfix">
                  {HCDLDP.map(({ id, title, text }) => (
                    <li
                      key={id}
                      className={`accordion block${
                        currentHCDLDP === id ? " active-block" : ""
                      }`}
                    >
                      <div
                        onClick={() => setCurrentHCDLDP(id)}
                        className={`acc-btn${
                          currentHCDLDP === id ? " active" : ""
                        }`}
                      >
                        <span className="count">{id}.</span> {title}
                      </div>
                      <div
                        className={`acc-content animated${
                          currentHCDLDP === id ? " current slideInUp" : ""
                        }`}
                      >
                        <div className="content">
                          <div className="text">{text}</div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
          <Col lg={6} md={12} sm={12} className="right-col">
            <div className="inner">
              <div className="sec-title">
                <h5>
                  <TextSplit text={title2} />
                  <span className="dot">.</span>
                </h5>
              </div>
              <div className="faq-box">
                <ul className="accordion-box clearfix">
                  {HCCS.map(({ id, title, text }) => (
                    <li
                      key={id}
                      className={`accordion block${currentHCCS === id ? " active-block" : ""
                        }`}
                    >
                      <div
                        onClick={() => setCurrentHCCS(id)}
                        className={`acc-btn${currentHCCS === id ? " active" : ""
                          }`}
                      >
                        <span className="count">{id}.</span> {title}
                      </div>
                      <div
                        className={`acc-content animated${currentHCCS === id ? " current slideInUp" : ""
                          }`}
                      >
                        <div className="content">
                          <div className="text">{text}</div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default WeDOSectionStaffSol;
